module.exports = __webpack_public_path__ + "img/kabin-pota.d1c4405d.png";